import { Box, FormControl, InputLabel } from '@mui/material'
import Select, { SelectProps } from '@mui/material/Select'
import React from 'react'
import {
  labelStyle,
  selectInputStyle,
  selectMenuStyle,
  selectSxStyle,
} from './HeaderSearchSelect.styles'

interface SearchSelectProps extends SelectProps {
  label: string
  value: string
  onChange: (event: any) => void
  optionsComponents: React.ReactNode
}

export const HeaderSearchSelect: React.FC<SearchSelectProps> = ({
  label,
  value,
  onChange,
  optionsComponents,
  ...props
}) => {
  return (
    <Box sx={{ minWidth: 120, maxWidth: 220 }} mr={1}>
      <FormControl fullWidth size="small">
        <InputLabel sx={labelStyle} id="demo-simple-select-label">
          {label}
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={label}
          value={value}
          inputProps={selectInputStyle}
          MenuProps={selectMenuStyle}
          sx={selectSxStyle}
          onChange={onChange}
          {...props}
        >
          {optionsComponents}
        </Select>
      </FormControl>
    </Box>
  )
}
